import axios from "axios";

const API = axios.create({
  baseURL: "https://cmsapi.mks.org.au/api",
  headers: {
    "Content-Type": "application/json"
  }
});

API.interceptors.request.use((config) => {

  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  console.log(`[API Request] ${config.method.toUpperCase()} ${config.url}`, config.data || '');
  return config;

});

API.interceptors.response.use(
  (response) => {
    console.log(`[API Success] ${response.config.method.toUpperCase()} ${response.config.url}:`, response.data);
    return response;
  },
  (error) => {
    console.error(`[API Error] ${error.config?.method?.toUpperCase()} ${error.config?.url}:`, error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default API;